import type { FaireProductEntity } from "../../entity_types/product";

export const p_ue8vjmyn7j: FaireProductEntity = {
  token: "p_ue8vjmyn7j",
  type: "product",
  name: "Figurine - Black/White Ceramic Standing Kitty, 7 in.",
  brandToken: "b_oigrk5zybt",
  brandName: "Sagebrook Home",
  imageUrl:
    "https://cdn.faire.com/fastly/6c4da08fa6d79303affe3de78f6e4d5f901f7e5d565b8c104148804be5396700.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7bb49cc2c23af0fa42d8662c7a3330d9b78368346e418ad2146204801f53a80.jpeg",
    "https://cdn.faire.com/fastly/5b79bca2e26ed049b7a650fe41eb097d4ee3a4d1fa7a5ff4f118c6894c069ea4.jpeg",
    "https://cdn.faire.com/fastly/8b219e4da8b2fa1b3b1e0e5052398475143b7e8e71b79e3d3f982bfffba341e4.jpeg",
    "https://cdn.faire.com/fastly/94501274d61113f8e51d2d4cb757a22f43f4f623cb0372219445b5ffad209a25.jpeg",
    "https://cdn.faire.com/fastly/c93a102b5eda482193758923aface99c2ba86542677fc8f5e1293053bcb8235d.jpeg",
    "https://cdn.faire.com/fastly/d048f380fc5b75a7c4ae7836abcfccea20e76a0b83058511935368c8ef1e8c92.jpeg",
    "https://cdn.faire.com/fastly/6363cf1367488f2053f2a027222c426aa9b029e0cd1258c6b053db0263234906.jpeg",
    "https://cdn.faire.com/fastly/bf497893ff2ab084024a69b6fef95c2dcb010d3cacf60ea12b2461ee59462861.jpeg",
    "https://cdn.faire.com/fastly/768081f900da54abe675f424c807b88ffe7b9dcd80fe87b4088aea5a3fc2b466.jpeg",
    "https://cdn.faire.com/fastly/4ff0f51189a024eaceb1666c9d5571bace0ea6da47090f50edf1f5e933b27b5c.jpeg",
    "https://cdn.faire.com/fastly/aef9f32ab46d30a2fd4f2303ed7e35bdc2febb3095cbe6ea4e45feba3eb21214.jpeg",
    "https://cdn.faire.com/fastly/4684e5c9ec5c8e544a6b97cd9fa608574d89bb49a455fbf0b858fff80776919a.jpeg",
  ],
  priceDollars: 15.24,
  description:
    "• BOHO-INSPIRED DESIGN - This stoneware ceramic figurine features a charming finish, adding a modern yet cozy touch to your home decor. Perfect for boho, minimalist, or contemporary styled spaces, it enhances warmth and personality in any room.\n• VERSATILE HOME ACCENT - Ideal for your living room, bedroom, office, or bookshelf, this artistic figurine seamlessly blends into any setting. Its neutral color palette complements various decor themes, making it a stylish statement piece.\n• HIGH-QUALITY CERAMIC CRAFTSMANSHIP - This figurine is built to last while maintaining a sleek, polished look. Designed to resist chipping and fading, it ensures long-lasting beauty with minimal maintenance for years of enjoyment.",
  tags: [],
  msrpDollars: 38.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:48.505Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
